// extracted by mini-css-extract-plugin
module.exports = {"DatiSideBar":"DatiSideBar_DatiSideBar__1UjqK","link":"DatiSideBar_link__1fOpn","credits":"DatiSideBar_credits__3ZZy3","Clear":"DatiSideBar_Clear__1hWPq"};